/// <reference path="../../../app.definition.ts" />
import { IAppRootScopeService } from '@/app/app.definition';
import angular, {IWindowService} from "angular";

export class AuthenticationController {
    static $inject = ["$rootScope", "$window"];

    constructor(
        $rootScope: IAppRootScopeService,
        $window: IWindowService
    ) {

        $rootScope.rootShowLoader = true;
        $window['localStorage']['tabCloseTime'] = -1;
    }
}

angular.module('eCareVault.authentication')
    .controller('AuthenticationController', AuthenticationController);
